import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type {
  CreateItemRequest,
  ItemDto,
  UpdateItemRequest,
} from './types';

const QK_LIST = ['items'] as const;

export function useItems(categoryId?: string | null) {
  return useQuery({
    queryKey: [...QK_LIST, { categoryId: categoryId ?? null }],
    queryFn: async () => {
      const params = categoryId ? { categoryId } : undefined;
      return (await apiClient.get<ItemDto[]>('/api/items', { params })).data;
    },
  });
}

export function useCreateItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreateItemRequest) =>
      (await apiClient.post<ItemDto>('/api/items', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useUpdateItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdateItemRequest }) =>
      (await apiClient.put<ItemDto>(`/api/items/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useDeleteItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/items/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}
